// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Redux Form
import { Field, reduxForm } from 'redux-form';

// Redux
import { connect } from 'react-redux';

// Translation
import { injectIntl, FormattedMessage } from 'react-intl';

// Locale
import messages from '../../locale/messages';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import {
    Grid,
    Button
} from 'react-bootstrap';
import s from './ListPlaceStep1.css';
import cs from '../../components/commonStyle.css';
import { Ship, Home, Compass } from 'lucide-react';

import update from './update';

// Component
import Avatar from '../Avatar';

// Images
import sayIcon from '/public/SiteIcons/sayIcon.png';
import arrowIcon from '/public/SiteIcons/letGoIcon.svg';
import footerImage from '/public/siteImages/onboardFooterImage.svg';

class ListIntro extends Component {

    static propTypes = {
        initialValues: PropTypes.object,
        hostDisplayName: PropTypes.string.isRequired,
        guestDisplayName: PropTypes.string,
        nextPage: PropTypes.any,
        hostPicture: PropTypes.string,
        guestPicture: PropTypes.string,
        userData: PropTypes.shape({
            firstName: PropTypes.string.isRequired
        }).isRequired
    };

    static defaultProps = {
        userData: {
            firstName: ''
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            roomType: [],
            personCapacity: [],
            selectedCategory: null, // No category selected by default
            showError: false // Show error message if no category selected
        }
    }

    UNSAFE_componentWillMount() {
        const { listingFields } = this.props;
        if (listingFields != undefined) {
            this.setState({
                roomType: listingFields.roomType,
                personCapacity: listingFields.personCapacity
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { listingFields } = nextProps;
        if (listingFields != undefined) {
            this.setState({
                roomType: listingFields.roomType,
                personCapacity: listingFields.personCapacity
            });
        }
    }


    handleCategorySelect = (category) => {
        this.setState({ selectedCategory: category, showError: false });
        // Also update redux-form value
        this.props.change('categoryType', category);
    }

    handleNext = () => {
        const { selectedCategory } = this.state;
        const { nextPage } = this.props;

        if (!selectedCategory) {
            this.setState({ showError: true });
            return;
        }

        nextPage('boat');
    }

    render() {
        const { nextPage, userData, hostPicture, hostDisplayName, guestDisplayName } = this.props;
        const { selectedCategory, showError } = this.state;

        const categories = [
            { id: 'boat', label: 'Bote / Yate', icon: Ship, description: 'Lanchas, yates, veleros' },
            { id: 'posada', label: 'Posada', icon: Home, description: 'Casas, apartamentos, cabañas' },
            { id: 'experience', label: 'Experiencia', icon: Compass, description: 'Tours, paseos, actividades' }
        ];

        return (
            <div className={cx(cs.textAlignCenter)}>
                {/* <div className={cx(s.listIntroBg, 'listIntroBgImage')} style={{ backgroundImage: `url(${BgImage})` }} ></div> */}
                <Grid fluid className={cx(s.listIntroContainers, s.listIntroBgSection)}>
                    <div className={s.userRight}>
                        <Avatar
                            isUser
                            title={guestDisplayName}
                            className={s.profileImage}
                            width={'120'}
                            height={'120'}
                        />
                    </div>
                    <h3 className={cx(cs.commonTitleText, cs.fontWeightBold, cs.spaceTop3)}><img src={sayIcon} className={s.sayCss} /> <FormattedMessage {...messages.hiText} />,<span className={s.userNameColor}>{userData.firstName}!</span></h3>
                    <p className={cx(cs.commonTotalText, cs.spaceTop3)}>¿Qué quieres publicar?</p>

                    {/* Category Selector Cards */}
                    <div className={s.categorySelector}>
                        {categories.map((cat) => {
                            const IconComponent = cat.icon;
                            return (
                                <div
                                    key={cat.id}
                                    className={cx(s.categoryCard, { [s.categoryCardActive]: selectedCategory === cat.id })}
                                    onClick={() => this.handleCategorySelect(cat.id)}
                                >
                                    <IconComponent size={32} className={s.categoryIcon} />
                                    <span className={s.categoryLabel}>{cat.label}</span>
                                    <span className={s.categoryDescription}>{cat.description}</span>
                                </div>
                            );
                        })}
                    </div>

                    {/* Hidden field to store categoryType in redux-form */}
                    <Field name="categoryType" component="input" type="hidden" />

                    {/* Error message if no category selected */}
                    {showError && (
                        <p style={{ color: '#dc3545', fontSize: '14px', marginTop: '16px', marginBottom: '8px' }}>
                            ⚠️ Debes seleccionar un tipo de propiedad para continuar
                        </p>
                    )}

                    <Button className={cx(s.button, s.btnPrimary, cs.spaceTop4)} onClick={this.handleNext}>
                        <FormattedMessage {...messages.LetsgoText} /> <img src={arrowIcon} className={cx('arrowIconListRTL', 'saveArrowCss')} />
                    </Button>
                </Grid>
                <img src={footerImage} className={cx(s.footerImageOnboard)} />
            </div>
        )
    }
}

ListIntro = reduxForm({
    form: 'ListPlaceStep1', // a unique name for this form
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onSubmit: update
})(ListIntro);

const mapState = (state) => ({
    userData: state.account.data,
    listingFields: state.listingFields.data
});

const mapDispatch = {
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(ListIntro)));